module.exports = __webpack_public_path__ + "static/mockup.b33438bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SnapPhone/mockup.png
// module id = 560
// module chunks = 153596302435155